'use client';

import { useFeatureGate } from '@statsig/react-bindings';
import { PropsWithChildren, ReactNode } from 'react';

import { COBRANDED_PARTNERS } from '@/app/configs/cobrandedPartners';
import { CobrandedProvider } from '@/app/contexts/CobrandedProvider';
import SessionProvider from '@/app/contexts/SessionProvider';
import { Partner } from '@/configs/partner';

import MaintenancePage from './maintenance/page';

export default function Layout({ children }: PropsWithChildren): ReactNode {
  const { value: isPartnerGateEnabled } = useFeatureGate('essence');

  if (isPartnerGateEnabled) {
    return (
      <SessionProvider partner={Partner.essence}>
        <CobrandedProvider config={COBRANDED_PARTNERS.essence}>
          {children}
        </CobrandedProvider>
      </SessionProvider>
    );
  }

  return <MaintenancePage />;
}
